/**
 * 작성자 : 홍선영
 * 날짜 : 2023.09.04
 * 경로 :  설정관리-협력업체관리-협력업체정보탭(현장관리자) 인풋폼
 */

import { useEffect, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import Input from '../Input';
import { BtnBlue, BtnRed } from '../Button';
import { useSetAuth } from '../../utils/useSetAuth';
import { applyBorderStyle } from '../../utils/applyBorderStyle';
import TextEditor from '../TextEditor';
import FileUploadButton from '../button/FileUploadButton';
import { useRecoilValue } from 'recoil';
import { userState } from '../../atoms';
import SwitchToggle from '../button/SwitchToggle';
import FormatImg from '../FormatImg';
import { v4 } from 'uuid';
import { collapseToast } from 'react-toastify/dist';
import { downloadFile } from '../../utils/flutterBridge';
import { isImageFile } from '../../utils/formatFilePath';
import { ImagePreview, PhotoImage } from '../ImagePreview';

interface IBoardEditorInputForm {
  state: any;
  setState: Dispatch<SetStateAction<any>>;
  isNewAdd?: boolean;
  userInfoInputFormRef: React.RefObject<any>;
  isSaveClicked: boolean;
  editorData: string;
  setEditorData: Dispatch<SetStateAction<string>>;
  filesState: { fileId?: string; file?: File; fileName?: string; fUrl?: string; fileFormat?: string }[];
  setFilesState: Dispatch<SetStateAction<{ fileId?: string; file?: File; fileName?: string; fUrl?: string; fileFormat?: string }[]>>;
  deleteFileIndex: string[];
  setDeleteFileIndex: Dispatch<SetStateAction<string[]>>;
  setOpenModal: Dispatch<SetStateAction<any>>;
}

const FileUpload = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  .file-total {
    color: var(--text-primary);
    font-size: 1rem;
  }
`;

const FileLists = styled.div`
  width: 100%;

  .file-inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.25rem;

    .file-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
      border-radius: 0.5rem;
      border: 1px solid var(--outline);
      padding: 0.5rem;

      .file {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        width: 100%;
        min-width: 0;

        .img-cont {
          width: 3rem;
          height: 3rem;
          border-radius: 0.25rem;
          overflow: hidden;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 0.25rem;
          }
        }

        span {
          font-size: 0.875rem;
          color: var(--text-primary);
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          flex: 1;
        }
      }

      .file-btn-wrap {
        display: flex;
        align-items: center;

        .file-btn {
          width: 2rem;
          height: 2rem;
          border-radius: 50%;
          padding: 0;
          background: transparent;

          &.download-btn {
            color: var(--primary);
          }

          &.remove-btn {
            color: var(--filled-red);
          }

          &:hover {
            background: var(--tonal-deep);
          }

          span.material-symbols-rounded {
            font-variation-settings: 'FILL' 1, 'wght' 400;
            font-size: 1.25rem;
          }
        }
      }

      &:hover {
        background: var(--tonal);
      }
    }
  }
`;

const Root = styled.div<{ isEditable?: boolean }>`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: fit-content;
  overflow: hidden;
  justify-content: flex-start;

  .useYn > div {
    justify-content: flex-start !important;
  }

  .editorWrapper {
    .ck-editor__main {
      .ck-content {
        min-height: 23rem;
      }
    }
    /*
    height: 100%;
    > div {
      height: 100%;
      .ck-editor {
        height: inherit;
        display: flex;
        flex-direction: column;
        .ck-editor__top {
          flex-shrink: 0;
        }
        .ck-editor__main {
          flex: 1;
          min-height: 18.75rem;
          max-height: 28rem;
          display: flex;
          flex-direction: column;
          .ck-content {
            flex: 1;
          }
        }
      }
    }
    .ck-editor__main.__web-inspector-hide-shortcut__ {
      flex: 1;
      min-height: 0;
    }
    @media screen and (max-width: 1024px) {
      height: auto;
      flex-shrink: 0;

      > div {
        height: auto;
        .ck-editor {
          height: auto;
          .ck-editor__main {
            height: auto;
            .ck-content {
              height: 16rem !important;
              min-height: 16rem;
            }
          }
        }
      }

      .ck.ck-editor__top {
        .ck-toolbar {
          flex-wrap: nowrap !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          -webkit-overflow-scrolling: touch;

          .ck-toolbar__items {
            flex-wrap: nowrap !important;
            min-width: max-content;
          }
        }
      }
    }
    */
  }
  .seperator {
    margin: 0.5rem 0;
    font-size: 0.875rem;
    display: flex;
    align-items: center;
    gap: 1rem;
    div {
      height: 1px;
      flex-grow: 1;
      background-color: rgba(0, 0, 0, 0.1);
    }
    span {
      border-bottom: 1px solid var(--outline);
    }
  }
  .inputForm {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem;
    flex-grow: 1;
    overflow: auto;
    button .editorWrapper {
      height: 2.5rem;
      font-size: 0.75rem;
      flex-shrink: 0;
      padding: 0 0.75rem;
      border-radius: 0.25rem;
    }
    button.gray {
      font-weight: 500;
      color: var(--zinc-200);
    }
    label {
      width: 6.5rem;
      font-weight: 500;
      flex-shrink: 0;
      font-size: 0.875rem;
    }
    .inputForm-group-1280 {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      @media (min-width: 1280px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
      }
    }
    .inputForm-group-1536 {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      > .datePickerWrapper {
        display: flex;
        flex-direction: row;
        gap: 0 !important;

        > div {
          margin-left: 0.5rem;
        }

        .wave {
          padding: 0 0.5rem;
        }
        .rdrDateRangePickerWrapper {
          position: absolute !important;
          top: auto !important;
          bottom: 100% !important;
          margin-bottom: 10px !important;

          position: absolute;
          top: 0.25rem;
          left: 50%;
          -webkit-transform: translate(-50%, 0);
          -ms-transform: translate(-50%, 0);
          transform: translate(-50%, 0);
          outline: 1px solid var(--outline);
          border-radius: 0.25rem;
          z-index: 5100;
          background-color: var(--board);
          z-index: 4999;
          margin-top: 0.25rem;
          box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
          box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
        }
      }

      @media (min-width: 1536px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 2rem;
      }
    }
    .inputForm-group-1536.withBtn {
      flex-direction: row;
      gap: 0.5rem;
      button {
        transition: none;
      }
      @media (min-width: 1536px) {
        gap: 2rem;
        button {
          margin-left: 0;
          width: fit-content;
        }
      }
    }
    .inputForm-group-1536.withBtn.inputColumnFour {
      input {
        padding: 0;
      }
    }
    .inputForm-row.labelInInput {
      display: flex;
      gap: 0.5rem;
      flex-grow: 1;
      > div {
        flex-grow: 1;
      }
    }
    .inputForm-row.labelInInput.noGrow {
      flex-grow: 0;
    }
    .inputForm-row.labelInInput.noGrow.title {
      width: 100%;
      display: flex;
      gap: 0.75rem;
      align-items: center;
      flex-wrap: wrap;
      > div {
        flex-grow: 1;
        min-width: 0;
      }
      > div > div {
        flex-direction: row;
        align-items: center;
        label {
          width: fit-content;
        }
      }
      .switch-toggle-wrapper {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        margin-left: auto;
        margin-right: 0;
        padding-left: 0.5rem;
        padding-right: 0;
        height: 2.5rem;
        > div {
          label {
            margin: 0;
            .label-name {
              min-width: auto;
              font-size: 0.875rem;
              color: var(--text-secondary);
              font-weight: 500;
              white-space: nowrap;
            }
          }
        }
        @media screen and (max-width: 767px) {
          margin-left: 0;
          padding-left: 0;
          margin-top: 0.5rem;
          justify-content: flex-start;
        }
      }
    }
    .inputForm-row.labelOutInput,
    .inputForm-row.labelInInput > div > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      input {
        flex-shrink: 1;
        height: 2.5rem;
        font-size: 0.875rem;
        padding: 0 0.5rem;
        &:disabled {
          background-color: var(--tonal);
          color: var(--text-disabled);
        }
      }
      > div.viewOnly {
        height: 2.5rem;
        font-size: 0.875rem;
        background-color: var(--tonal);
        color: var(--text-disabled);
        border-radius: 0.25rem;
        padding: 0 0.75rem;
        display: flex;
        align-items: center;
      }
      > div {
        flex-grow: 1;
        > ul {
          height: 2.5rem;
          li {
            display: flex;
            width: 100%;
            max-width: 100%;
            span {
              flex-grow: 1;
              width: 4rem;
            }
          }
        }
      }
    }
    .detailInfo-group {
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
      margin-top: 0.5rem;

      .detailInfo-text {
        display: flex;
        align-items: center;
        gap: 0.375rem;
        font-size: 0.75rem;
        color: var(--text-tertiary);
        .label {
          color: var(--text-tertiary);
        }
        .value {
          color: var(--text-tertiary);
        }
        .time {
          color: var(--text-tertiary);
        }
      }

      @media screen and (max-width: 768px) {
        & {
          flex-direction: column;
          align-items: flex-end;
          gap: 0;
        }
      }
    }

    .date-picker-btn {
      width: 2.5rem;
      height: 2.5rem;
      padding: 0 1rem;
      border-left: 1px solid var(--outline);
      background-color: var(--tonal);
      border-radius: 0;
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;

      &:hover {
        background-color: var(--outline);
      }

      > span {
        font-size: 16px;
        color: var(--text-primary);
      }
    }

    @media screen and (max-width: 767px) {
      & {
        padding: 0.5rem 0;
      }
    }
  }

  .uploadForm {
    flex-direction: column;
    gap: 0.5rem;
  }

  input {
    :disabled {
      background-color: #eeeeee;
    }
  }
  .required {
    &::after {
      content: '*';
      padding: 0 0.2rem;
      color: red;
    }
  }
  @media screen and (max-width: 1024px) {
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    /* padding-top: 5rem; */
    height: fit-content;
    overflow: none;
  }
`;

const BoardEditorInputForm = ({
  state,
  setState,
  isNewAdd,
  userInfoInputFormRef,
  isSaveClicked,
  editorData,
  setEditorData,
  filesState,
  setFilesState,
  deleteFileIndex,
  setDeleteFileIndex,
  setOpenModal,
}: IBoardEditorInputForm) => {
  const { t } = useTranslation();
  const { auth } = useSetAuth(); // 사용자 권한값 훅
  const userInfo = useRecoilValue(userState);

  useEffect(() => {
    if (state.contents !== undefined) setEditorData(state.contents);
  }, [state.contents]);

  const onSelectFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    const mapped = files.map((file: File) => ({
      file,
      fileId: v4() as string,
      fileName: file.name,
      fileFormat: file.name.slice(file.name.lastIndexOf('.') + 1),
      fUrl: '',
    }));
    setFilesState((prev) => [...prev, ...mapped]);
    e.target.value = '';
  };

  const onRemoveFile = (idx: number) => {
    const target = filesState[idx];
    if (target?.file === undefined && target?.fileId !== undefined) {
      setDeleteFileIndex((prev) => [...prev, target?.fileId as string]);
    }
    setFilesState((prev) => prev.filter((_, i) => i !== idx));
  };

  const handleFileDownload = async (fileUrl: string, fileName: string) => {
    try {
      await downloadFile(fileUrl.replace('+', '%2B'), fileName);
    } catch (err) {
      console.error('There was an error:', err);
    }

    /*
    try {
      if (!fileUrl) return;
      const a = document.createElement('a');
      a.href = fileUrl;
      a.download = fileName || '';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } catch (err) {
      console.error(err);
    }
    */
  };

  const isEditable = isNewAdd || (!isNewAdd && state.userId === userInfo.userId) || userInfo.gCd === 'MM';

  return (
    <Root isEditable={isEditable}>
      <div className='inputForm' ref={userInfoInputFormRef}>
        <div className='inputForm-row labelInInput noGrow title'>
          <Input
            className='required'
            label={t('제목')}
            type='text'
            id='title'
            name='title'
            state={state}
            setState={setState}
            disabled={!isEditable}
            getBorderStyle={isSaveClicked ? applyBorderStyle(state.title, 'red', 'title') : undefined}
            maxLength={100}
          />
          <div className='switch-toggle-wrapper'>
            <SwitchToggle label={t('공지')} hFor='noticeYn' state={state.noticeYn === 'Y'} setState={(value) => setState((prev: any) => ({ ...prev, noticeYn: value ? 'Y' : 'N' }))} />
          </div>
        </div>
        <div className='editorWrapper'>
          <TextEditor content={editorData} setContent={setEditorData} readOnly={!isEditable} toolOptionType='short' />
        </div>
        <div className='flex-basic uploadForm'>
          <FileUpload className='flex-basic uploadHead'>
            <div className='file-total'>
              {t('첨부된 파일')} ( {filesState.length || 0} )
            </div>

            {auth.updateAuth && isEditable && <FileUploadButton id='files' name='files' label='파일 첨부' ico='upload' accept='*' multiple='Y' handleChange={onSelectFiles} allowAllFileTypes='all' />}
          </FileUpload>

          {/* <FileUpload /> */}
          {/* <FileLists /> */}

          {filesState.length > 0 && (
            <FileLists className='file-wrap'>
              <ImagePreview imageList={filesState.filter((file: any) => isImageFile(file.fileName))}>
                <div className='file-inner'>
                  {filesState.map((el: any, idx) => (
                    <div key={el.fileId} className='file-item'>
                      <div className='file'>
                        {isImageFile(el.fileName) ? <PhotoImage file={el} size={48} borderRadius={0.25} /> : <FormatImg format={el.fileFormat} type='text' />}
                        <span>{el.fileName}</span>
                      </div>

                      <div className='flex-basic file-btn-wrap'>
                        {el.fUrl !== '' && (
                          <BtnBlue className='file-btn download-btn' onClick={() => handleFileDownload(el.fUrl || '', el.fileName || '')} title={t('파일 다운로드')}>
                            <span className='material-symbols-rounded'>download</span>
                          </BtnBlue>
                        )}
                        {auth.updateAuth && isEditable && (
                          <BtnRed className='file-btn remove-btn' onClick={() => onRemoveFile(idx)} title={t('파일 제거')}>
                            <span className='material-symbols-rounded'>close</span>
                          </BtnRed>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </ImagePreview>
            </FileLists>
          )}
        </div>

        {!isNewAdd ? (
          <div className='detailInfo-group'>
            <div className='detailInfo-text'>
              <span className='label'>{t('등록자')}:</span>
              <span className='value'>{state.writer}</span>
              {state?.wDate && <span className='time'>({state?.wDate})</span>}
            </div>
            {state?.wDate !== state?.eDate && (
              <div className='detailInfo-text'>
                <span className='label'>{t('수정자')}:</span>
                <span className='value'>{state.editor}</span>
                {state?.eDate && <span className='time'>({state?.eDate})</span>}
              </div>
            )}
          </div>
        ) : undefined}
      </div>
    </Root>
  );
};

export default BoardEditorInputForm;
